import { Component, OnInit } from "@angular/core";
import { BaseComponent, UserService, HelperService, WindowService, OrderService } from "@mypxplat/xplat/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-account-gift-cards",
  templateUrl: "./gift-cards.component.html",
  standalone: false,
})
export class GiftCardsComponent extends BaseComponent implements OnInit {
  public loading: boolean;
  public giftCards: Array<any>;
  constructor(
    public userService: UserService,
    public helperService: HelperService,
    private _win: WindowService,
    private _router: Router,
    private _route: ActivatedRoute,
    public appService: AppService,
    public orderService: OrderService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loading = true;
    this.orderService.getFenderShopifyAccountDetails(this.userService.user.email, true).subscribe((result: any) => {
      if (result?.shopifyId) {
        setTimeout(() => {
          this.orderService.getFenderGiftCards(result.shopifyId, result.storeId).subscribe((giftCards: any) => {
            this.giftCards = giftCards;
            this.loading = false;
          });
        }, 100);
      } else {
        this.loading = false;
        this.giftCards = [];
      }
    });
  }
}
